import { computed, toValue } from "vue";
const CLIENT_NAME_PRIORITY = {
    "Extole Defaults V9": 1,
    "Extole Defaults V8": 2,
    "Extole Beta": 3,
};
export const useDefaultGranterClientId = (componentGranters, availableClientIds) => {
    const grantersByPriority = computed(() => {
        const granters = toValue(componentGranters);
        return [...granters].sort((a, b) => {
            var _a, _b;
            const priorityA = (_a = CLIENT_NAME_PRIORITY[a.client_name]) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER;
            const priorityB = (_b = CLIENT_NAME_PRIORITY[b.client_name]) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER;
            if (priorityA !== priorityB) {
                return priorityA - priorityB;
            }
            return 0;
        });
    });
    const defaultGranterClientId = computed(() => {
        const granters = grantersByPriority.value;
        const availableIds = toValue(availableClientIds);
        const firstAvailableGranter = granters.find((granter) => availableIds.includes(granter.client_id));
        return firstAvailableGranter === null || firstAvailableGranter === void 0 ? void 0 : firstAvailableGranter.client_id;
    });
    return {
        defaultGranterClientId,
    };
};
